import { DEFAULT_NOTIFICATION_SETTINGS } from "@/consts";
import type {
  InputMaybe,
  NotificationSettingsInput,
} from "@/graphql/generated-types";
import { useAuthStore } from "@/stores/auth.module";

type DefaultGetter = () => NotificationSettingsInput;

type APIData = {
  id?: InputMaybe<string> | undefined;
  notificationSettings?: {
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
  } | null;
  institution?: {
    id: string;
  };
};

type Item = {
  id?: string | number | null;
};

export default (data: APIData, item: Item, getDefaults: DefaultGetter) => {
  const authStore = useAuthStore();

  let settings: NotificationSettingsInput;
  if (data.notificationSettings) {
    const { status, reminderFirst, reminderSecond } = data.notificationSettings;
    settings = {
      ...getDefaults(),
      status,
      reminderFirst,
      reminderSecond,
    };
  } else if (item.id) {
    settings = {
      ...DEFAULT_NOTIFICATION_SETTINGS,
    };
  } else {
    settings = {
      ...getDefaults(),
    };
  }

  settings.entityId = data.id;
  settings.institution =
    data.institution?.id?.toString() || authStore.institutionId;

  return settings;
};
